import React from 'react'
import YouTube from 'react-youtube';
import styles from './GroupAppYoutube.module.scss'

const GroupAppYoutube = ({ videoId, opts, extraClass }: { videoId: any, opts: any, extraClass?: string | undefined }) => {
    return (
        <div className={`${styles.ytPlayerWrapper} ${extraClass}`}>
            <YouTube
                // @ts-ignore
                opts={opts}
                videoId={videoId}
                className={styles.ytPlayer}
                onReady={(event: any) => {
                    const iframe = event.target.getIframe();
                    if (iframe.hasAttribute('illow-src')) {
                        iframe.removeAttribute('illow-src');
                    }
                }}
            />
        </div>
    )
}

export default GroupAppYoutube